import { SetStateAction } from "react";
import { MRT_RowSelectionState } from "material-react-table";
import { AssignedBookableEquipment } from "../../../../../Domain/Types/FloorPlan/BookableEquipmentAssignment.type";

/** handle the initial bookable equipment selection in the table  */
export const handleInitialBookableEquipmentSelect = (
  assigned: AssignedBookableEquipment[],
  setRowSelection: (value: SetStateAction<MRT_RowSelectionState>) => void
) => {
  const usedEquip = assigned.map(as => as.bookableEquipmentId);
  if (!usedEquip.length) return;

  for (const equip of usedEquip) {
    setRowSelection(prev => ({ ...prev, [`${equip}`]: true }));
  }
};
